/* Complete packs: one fully paid BBQ portion plus one dessert portion. */
(() => {
  if (window.sizzlinCompletePackCartInstalled) return;
  window.sizzlinCompletePackCartInstalled = true;
  const packs = {
    "15523102523586": { bbq: 67851945935042, dessert: 67851949670594, parentPlan: "6263603394", title: "Complete Mini Meltdown" },
    "15523102589122": { bbq: 67851946000578, dessert: 67851949703362, parentPlan: "6263570626", title: "Complete Meltdown" }
  };
  window.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const component = form.closest("product-form-component");
    const pack = component && packs[component.dataset.productId];
    if (!pack) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.completePackBusy === "true") return;
    if (!form.reportValidity()) return;
    const data = new FormData(form);
    const quantity = Number(data.get("quantity") || 1);
    let error = form.querySelector("[data-complete-pack-error]");
    if (!error) {
      error = document.createElement("p");
      error.dataset.completePackError = "";
      error.setAttribute("role", "alert");
      form.append(error);
    }
    error.textContent = "";
    if (!Number.isSafeInteger(quantity) || quantity < 1) {
      error.textContent = "Please enter a valid pack quantity.";
      return;
    }
    const selectedPlan = String(data.get("selling_plan") || "");
    if (selectedPlan && selectedPlan !== pack.parentPlan) {
      error.textContent = "Please refresh this page and select a purchase option again.";
      return;
    }
    const properties = { "Complete pack": pack.title };
    for (const [key, value] of data.entries()) {
      const match = /^properties\[(.+)\]$/.exec(key);
      if (match && typeof value === "string" && value.trim()) properties[match[1]] = value.trim();
    }
    const group = typeof crypto.randomUUID === "function" ? crypto.randomUUID() : String(Date.now()) + "-" + Math.random().toString(36).slice(2);
    properties._complete_pack_group = group;
    const dessert = { id: pack.dessert, quantity, properties: { ...properties, "Shipment": "Dessert shipment — standard shipping included" } };
    if (selectedPlan) dessert.selling_plan = 6243320002;
    const items = [
      { id: pack.bbq, quantity, properties: { ...properties, "Shipment": "BBQ sauces and rubs — first shipment" } },
      dessert
    ];
    form.dataset.completePackBusy = "true";
    form.setAttribute("aria-busy", "true");
    const buttons = Array.from(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
    const states = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    try {
      const response = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || "The pack could not be added.");
      window.location.assign(root + "cart");
    } catch (failure) {
      error.textContent = (failure && failure.message) || "Unable to add the pack. Please check your cart before trying again.";
      form.dataset.completePackBusy = "false";
      form.removeAttribute("aria-busy");
      buttons.forEach((button, index) => { button.disabled = states[index]; });
    }
  }, true);
})();
